import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { getEditableScheduledRunId } from 'state/blotters/scheduledQuotes';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { EpicWithThunk } from 'state/state.common';
import { type HttpError, toTypedError } from 'utils/http/httpClient.model';

export function deleteScheduledRunEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) => {
    const { deleteRunById } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_DELETE_SCHEDULE_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) => {
        const runId = getEditableScheduledRunId(state);
        if (!runId) {
          return EMPTY;
        }
        return deleteRunById(runId).pipe(
          map(() => scheduledRunActions.deleteScheduleSucceeded(id, runId)),
          catchError((err: HttpError) => {
            return of(scheduledRunActions.deleteScheduleFailed(id, toTypedError('Pricing Runs DIY', err)));
          }),
        );
      }),
    );
  };
}
